import { CardItem } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './styled';
import type { MtCardItemLitterProps } from './types';

export * from './types';

export const MtCardItemLitter: FC<MtCardItemLitterProps> = (props) => {
  const {
    onClick,
    image,
    breed,
    price,
    futureLitter,
    waiting = false,
    archived = false,
    ...rest
  } = props;

  const { translate } = useTranslation();

  return (
    <CardItem
      image={image}
      onClick={onClick}
      imageOverlay={
        (!!futureLitter || waiting || archived) && (
          <Styled.ImageOverlayContainer>
            {archived ? (
              translate('glossary.archives')
            ) : (
              <>
                {!!futureLitter && (
                  <div>
                    {translate('glossary.litterExpected')} {futureLitter.month} {futureLitter.year}
                  </div>
                )}

                {waiting && <Styled.WaitingTag>{translate('glossary.waiting')}</Styled.WaitingTag>}
              </>
            )}
          </Styled.ImageOverlayContainer>
        )
      }
      content={{
        title: breed,
        subtitle: price && (
          <>
            <Styled.PurpleSpan>{price}</Styled.PurpleSpan>
          </>
        ),
      }}
      {...rest}
    />
  );
};
